import {
    UPDATE_MIS_TEAM,
    updateMisTeamSuccess,
    updateMisTeamFailure,
    FETCH_MIS_TEAM_BY_ID,
    fetchMisTeamByIdSuccess,
    fetchMisTeamByIdFailure,
    MIS_TEAM_LIST,
    getMisTeamSuccess,
    getMisTeamFailure,
    FETCH_MIS_FIELDS,
    fetchMisFieldsSuccess,
    fetchMisFieldsFailure,
    FETCH_DEFAULT_MIS_FIELDS,
    fetchDefaultMisFieldsSuccess,
    fetchDefaultMisFieldsFailure

} from './action';
import { takeLatest, put, call } from 'redux-saga/effects';
import { HTTP_HEADERS } from '../../constants';
import request from '../../components/Utils/httpHelper';
import { CORE_API, REPORT } from '../../config';


export function* updateMisTeamSaga(action) {

    let requestUrl = `${CORE_API}/misTeam/update`;
    try {
        const updateMisTeamResp = yield call(request, requestUrl, { data: action.data, method: 'POST', headers: HTTP_HEADERS });
        yield put(updateMisTeamSuccess(updateMisTeamResp.data));
    } catch (err) {
        yield put(updateMisTeamFailure(err.response));
    }
}


export function* updateMisTeam() {
    yield takeLatest(UPDATE_MIS_TEAM, updateMisTeamSaga);
}


export function* fetchMisTeamByIdSaga(action) {

    let requestUrl = `${CORE_API}/misTeam/fetch/${action.data}`;
    try {
        const fetchMisTeamByIdResp = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS });
        yield put(fetchMisTeamByIdSuccess(fetchMisTeamByIdResp.data));
    } catch (err) {
        yield put(fetchMisTeamByIdFailure(err.response));
    }
}


export function* fetchMisTeamById() {
    yield takeLatest(FETCH_MIS_TEAM_BY_ID, fetchMisTeamByIdSaga);
}

export function* getMisTeamSaga(action) {

    let requestUrl = `${CORE_API}/misTeam/list`;
    try {
        const misTeamList = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS });
        yield put(getMisTeamSuccess(misTeamList.data));
    } catch (err) {
        yield put(getMisTeamFailure(err.response));
    }
}


export function* getMisTeam() {
    yield takeLatest(MIS_TEAM_LIST, getMisTeamSaga);
}



export function* fetchDefaultMisFieldsSaga() {
    let requestUrl = `${CORE_API}/misfield/default/list`;
    try {
        const defaultMisFieldList = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS });
        yield put(fetchDefaultMisFieldsSuccess(defaultMisFieldList.data))
    }
    catch (err) {
        yield put(fetchDefaultMisFieldsFailure(err))
    }
}
export function* fetchDefaultMisFields() {
    yield takeLatest(FETCH_DEFAULT_MIS_FIELDS, fetchDefaultMisFieldsSaga);
}


export function* fetchMisFieldsSaga() {
    let requestUrl = `${CORE_API}/misfield/list`;
    try {
        const misFieldList = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS });
        yield put(fetchMisFieldsSuccess(misFieldList.data))
    }
    catch (err) {
        yield put(fetchMisFieldsFailure(err))
    }
}
export function* fetchMisFields() {
    yield takeLatest(FETCH_MIS_FIELDS, fetchMisFieldsSaga);
}